import React from "react";
import Button from "@Components/Button";
import Upload from "@Components/Icons/Upload";
import styles from "./index.module.scss";
export default function UploadBills(props) {
    return (React.createElement("div", { className: styles.card },
        React.createElement("div", { className: styles.header },
            React.createElement("div", { className: styles.headerTop },
                React.createElement("div", { className: styles.iconWrapper },
                    React.createElement(Upload, { size: "16px", success: true })),
                React.createElement("div", { className: styles.titleWrapper },
                    React.createElement("h2", { className: styles.title }, "Upload your Bill Reports"))),
            React.createElement("p", { className: styles.description }, "While not mandatory, this will give the ideal results"),
            React.createElement("div", { className: styles.contentBox },
                React.createElement("p", { className: styles.analysisTitle }, "Our analysis identifies:"),
                React.createElement("div", { className: styles.list },
                    React.createElement("div", { className: styles.listItem },
                        React.createElement("p", { className: styles.listText }, "Number of lines on your account")),
                    React.createElement("div", { className: styles.listItem },
                        React.createElement("p", { className: styles.listText }, "Number of these lines you use")),
                    React.createElement("div", { className: styles.listItem },
                        React.createElement("p", { className: styles.listText }, "Data usage and future needs")),
                    React.createElement("div", { className: styles.listItem },
                        React.createElement("p", { className: styles.listText }, "Predicted new contract saving"))),
                React.createElement("div", { className: styles.resultsRow },
                    React.createElement("p", { className: styles.resultsText }, "Results shown in boxes"),
                    React.createElement("div", { className: styles.badge },
                        React.createElement("span", { className: styles.badgeText }, "00"))))),
        React.createElement("div", { className: styles.buttonWrapper },
            React.createElement(Button, { click: props.upload, newBlueCta: true, small: true },
                React.createElement(Upload, { size: "16px", light: true }),
                "UPLOAD BILL REPORTS"))));
}
